export default __webpack_public_path__ + "static/logo-white-bd9bfeafc3da0d5ce59351912598b23a.svg";